import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const SLIDES = [
  {
    title: "The Luxury Collection",
    overline: "Heirloom · Eternal",
    desc: "Master-cut diamonds and rare gemstones, crafted to outlast generations.",
    cta: "Explore Collection", to: "/shop?is_best_seller=true",
    img: "https://images.pexels.com/photos/2732096/pexels-photo-2732096.jpeg",
  },
  {
    title: "Made Personal",
    overline: "Bespoke · Engraved",
    desc: "Initials, birthstones, signets. Designed around the moments that matter.",
    cta: "Personalize Yours", to: "/shop?is_personalized=true",
    img: "https://i.ibb.co/23qVRHn1/file-000000000484720695a4e8c3974dd554.png",
  },
  {
    title: "Lab Grown Brilliance",
    overline: "Sustainable · Certified",
    desc: "Identical to mined diamonds, with a lighter footprint and finer price.",
    cta: "Shop Lab Grown", to: "/shop?is_lab_grown=true",
    img: "https://images.pexels.com/photos/14509640/pexels-photo-14509640.jpeg",
  },
];

const CATEGORIES = [
  { name: "Rings", url: "https://images.pexels.com/photos/2849742/pexels-photo-2849742.jpeg", q: "category=Rings" },
  { name: "Necklaces", url: "https://images.unsplash.com/photo-1589128777073-263566ae5e4d", q: "category=Necklaces" },
  { name: "Bracelets", url: "https://images.pexels.com/photos/37485307/pexels-photo-37485307.jpeg", q: "category=Bracelets" },
  { name: "Earrings", url: "https://images.pexels.com/photos/28369714/pexels-photo-28369714.jpeg", q: "category=Earrings" },
  { name: "Diamond", url: "https://images.unsplash.com/photo-1605100804763-247f67b3557e", q: "gemstone=Diamond" },
  { name: "Gold", url: "https://images.unsplash.com/photo-1611107683227-e9060eccd846", q: "metal=18K%20Gold" },
  { name: "Silver", url: "https://images.unsplash.com/photo-1607703829739-c05b7beddf60", q: "metal=Silver" },
  { name: "Bridal", url: "https://images.pexels.com/photos/10862233/pexels-photo-10862233.jpeg", q: "occasion=Wedding" },
];

const REVIEWS = [
  { name: "Aanya M.", city: "Mumbai", text: "The craftsmanship is otherworldly. My solitaire arrived in a heritage box that made the moment unforgettable." },
  { name: "Sofia L.", city: "London", text: "Wore the Aurora pearls to a gala — three strangers stopped me to ask where they were from." },
  { name: "Rhea K.", city: "Delhi", text: "Personalized signet for my husband. The engraving was so delicate. Absolute heirloom." },
  { name: "Maya P.", city: "Singapore", text: "I usually buy from European houses. Jewels Ashu is now my secret." },
];

const INSTA = [
  "https://images.pexels.com/photos/36599395/pexels-photo-36599395.jpeg",
  "https://images.pexels.com/photos/20838859/pexels-photo-20838859.jpeg",
  "https://images.unsplash.com/photo-1543294001-f7cd5d7fb516",
  "https://images.unsplash.com/photo-1588444968576-f8fe92ce56fd",
  "https://images.unsplash.com/photo-1592317295760-5c1f677dfc78",
  "https://images.unsplash.com/photo-1608042314453-ae338d80c427",
];

const BIRTHSTONES = [
  { m: "Jan", s: "Garnet" }, { m: "Feb", s: "Amethyst" }, { m: "Mar", s: "Aquamarine" },
  { m: "Apr", s: "Diamond" }, { m: "May", s: "Emerald" }, { m: "Jun", s: "Pearl" },
  { m: "Jul", s: "Ruby" }, { m: "Aug", s: "Peridot" }, { m: "Sep", s: "Sapphire" },
  { m: "Oct", s: "Opal" }, { m: "Nov", s: "Citrine" }, { m: "Dec", s: "Topaz" },
];

export default function Home() {
  const [slide, setSlide] = useState(0);
  const [featured, setFeatured] = useState([]);
  const [arrivals, setArrivals] = useState([]);
  const [best, setBest] = useState([]);
  const [personalized, setPersonalized] = useState([]);
  const [labGrown, setLabGrown] = useState([]);
  const [birthstone, setBirthstone] = useState([]);

  useEffect(() => {
    const t = setInterval(() => setSlide((s) => (s + 1) % SLIDES.length), 5000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    (async () => {
      const [f, n, b, per, lab, bs] = await Promise.all([
        api.get("/products", { params: { limit: 4 } }),
        api.get("/products", { params: { is_new: true, limit: 4 } }),
        api.get("/products", { params: { is_best_seller: true, limit: 4 } }),
        api.get("/products", { params: { is_personalized: true, limit: 4 } }),
        api.get("/products", { params: { is_lab_grown: true, limit: 4 } }),
        api.get("/products", { params: { is_birthstone: true, limit: 4 } }),
      ]);
      setFeatured(f.data); setArrivals(n.data); setBest(b.data);
      setPersonalized(per.data); setLabGrown(lab.data); setBirthstone(bs.data);
    })();
  }, []);

  const current = SLIDES[slide];

  return (
    <div>
      {/* HERO */}
     <section className="relative h-[65vh] w-screen overflow-hidden" data-testid="hero-slider">
        {SLIDES.map((s, i) => (
          <div key={s.title} className={`absolute inset-0 transition-opacity duration-1000 ${i === slide ? "opacity-100" : "opacity-0"}`}>
            <img
  src={s.img}
  alt=""
  className={`absolute inset-0 w-full h-full ${
    i === 1 ? "object-contain" : "object-cover"
  }`}
/>
            <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.55) 100%)" }} />
          </div>
        ))}<div className="relative h-full w-full flex items-end px-6 pb-24">
          <div className="max-w-2xl text-white ja-fade-up" key={slide}>
            <p className="text-[11px] tracking-[0.4em] uppercase" style={{ color: "var(--ja-champagne)" }}>{current.overline}</p>
            <h1 className="mt-6 ja-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight">{current.title}</h1>
            <p className="mt-6 max-w-md text-base font-light">{current.desc}</p>
            <Link to={current.to} className="ja-btn mt-10" style={{ background: "var(--ja-ivory)", color: "var(--ja-black)", borderColor: "var(--ja-ivory)" }} data-testid="hero-cta">
              {current.cta}
            </Link>
          </div>
        </div>
        <button onClick={() => setSlide((slide - 1 + SLIDES.length) % SLIDES.length)} className="absolute left-6 top-1/2 -translate-y-1/2 text-white" data-testid="hero-prev"><ChevronLeft size={28} /></button>
        <button onClick={() => setSlide((slide + 1) % SLIDES.length)} className="absolute right-6 top-1/2 -translate-y-1/2 text-white" data-testid="hero-next"><ChevronRight size={28} /></button>
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2">
          {SLIDES.map((_, i) => (
            <button key={i} onClick={() => setSlide(i)} className={`h-[2px] transition-all ${i === slide ? "w-12 bg-white" : "w-6 bg-white/40"}`} data-testid={`hero-dot-${i}`} />
          ))}
        </div>
      </section>

      {/* CATEGORIES */}
      <section className="ja-section ja-container" data-testid="categories-section">
        <div className="text-center mb-16">
          <p className="ja-overline">The House</p>
          <h2 className="ja-serif text-4xl md:text-5xl mt-3 tracking-tight">Shop By Category</h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {CATEGORIES.map((c) => (
            <Link key={c.name} to={`/shop?${c.q}`} className="group text-center" data-testid={`category-link-${c.name.toLowerCase()}`}>
              <div className="aspect-square overflow-hidden bg-white">
                <img src={c.url} alt={c.name} className="w-full h-full object-cover ja-hover-img" loading="lazy" />
              </div>
              <p className="ja-serif text-xl mt-5 group-hover:underline">{c.name}</p>
            </Link>
          ))}
        </div>
      </section>

      {/* FEATURED COLLECTIONS - editorial */}
      <section className="ja-container py-12" data-testid="featured-section">
        <div className="grid md:grid-cols-12 gap-8 md:gap-16 items-center">
          <div className="md:col-span-5 md:order-2">
            <p className="ja-overline">Featured Collection</p>
            <h2 className="ja-serif text-4xl md:text-6xl mt-4 tracking-tight leading-tight">Quiet Brilliance, Loud Presence.</h2>
            <p className="mt-6 text-base" style={{ color: "var(--ja-muted)" }}>
              Each piece in the Featured Edit is hand-selected by our atelier — the rarest stones, the cleanest cuts, the most patient hands.
            </p>
            <Link to="/shop" className="ja-btn-outline mt-10" data-testid="featured-cta">Discover the Edit</Link>
          </div>
          <div className="md:col-span-7 md:order-1 grid grid-cols-2 gap-4">
            {featured.slice(0, 4).map((p, i) => (
              <Link key={p.id} to={`/product/${p.id}`} className={`block overflow-hidden ${i === 0 ? "aspect-[3/4] col-span-2 md:col-span-1 md:row-span-2 md:aspect-auto md:h-full" : "aspect-square"}`}>
                <img src={p.images?.[0]} alt={p.name} className="w-full h-full object-cover ja-hover-img" loading="lazy" />
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* NEW ARRIVALS */}
      <SectionGrid title="New Arrivals" overline="Just In" testid="new-arrivals" items={arrivals} ctaTo="/shop?is_new=true" />

      {/* BEST SELLERS */}
      <SectionGrid title="Best Sellers" overline="Most Loved" testid="best-sellers" items={best} ctaTo="/shop?is_best_seller=true" />

      {/* PERSONALIZED */}
      <Storytelling
        overline="Personalized Jewellery"
        title="Yours, Forever Engraved."
        desc="Initials, dates, secret messages. Hand-engraved by our master craftsmen in 14K and 18K gold."
        cta="Begin Yours" ctaTo="/shop?is_personalized=true"
        img="https://images.unsplash.com/photo-1543294001-f7cd5d7fb516"
        items={personalized}
        testid="personalized-section"
      />

      {/* LAB GROWN */}
      <Storytelling
        reverse
        overline="Lab Grown Diamonds"
        title="The Future, in Carats."
        desc="Optically and chemically identical to mined diamonds — at a fraction of the footprint."
        cta="Explore Lab Grown" ctaTo="/shop?is_lab_grown=true"
        img="https://images.pexels.com/photos/14509640/pexels-photo-14509640.jpeg"
        items={labGrown}
        testid="lab-grown-section"
      />

      {/* MAKE YOUR OWN */}
      <section className="ja-section" data-testid="make-your-own">
        <div className="ja-container">
          <div className="relative overflow-hidden">
            <img src="https://images.pexels.com/photos/972937/pexels-photo-972937.jpeg" alt="" className="w-full h-[60vh] object-cover" />
            <div className="absolute inset-0 flex items-center" style={{ background: "linear-gradient(90deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.0) 60%)" }}>
              <div className="px-10 md:px-20 max-w-xl text-white">
                <p className="text-[11px] tracking-[0.4em] uppercase" style={{ color: "var(--ja-champagne)" }}>Atelier Service</p>
                <h2 className="mt-4 ja-serif text-4xl md:text-6xl tracking-tight">Make Your Own.</h2>
                <p className="mt-6 max-w-md">From sketch to setting — design a one-of-one piece with our master jewellers over a private consultation.</p>
                <Link to="/make-your-own" className="ja-btn mt-8" style={{ background: "var(--ja-ivory)", color: "var(--ja-black)", borderColor: "var(--ja-ivory)" }} data-testid="make-your-own-cta">Book Consultation</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BIRTHSTONE */}
      <section className="ja-section ja-container" data-testid="birthstone-section">
        <div className="text-center mb-16">
          <p className="ja-overline">By Birth Month</p>
          <h2 className="ja-serif text-4xl md:text-5xl mt-3 tracking-tight">Birthstone Collection</h2>
        </div>
        <div className="grid grid-cols-3 md:grid-cols-6 lg:grid-cols-12 gap-3">
          {BIRTHSTONES.map((b) => (
            <Link key={b.m} to={`/shop?gemstone=${b.s}`} className="text-center py-6 px-2 border hover:bg-white transition-colors" style={{ borderColor: "var(--ja-border)" }} data-testid={`birthstone-${b.m.toLowerCase()}`}>
              <p className="ja-serif text-2xl">{b.m}</p>
              <p className="text-[10px] tracking-[0.2em] uppercase mt-1" style={{ color: "var(--ja-muted)" }}>{b.s}</p>
            </Link>
          ))}
        </div>
        {birthstone.length > 0 && (
          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-12">
            {birthstone.map((p, i) => <ProductCard key={p.id} p={p} idx={i} />)}
          </div>
        )}
      </section>

      {/* REWARDS */}
      <section className="ja-section" style={{ background: "var(--ja-ivory)" }} data-testid="rewards-section">
        <div className="ja-container">
          <div className="text-center mb-16">
            <p className="ja-overline">Members Only</p>
            <h2 className="ja-serif text-4xl md:text-5xl mt-3 tracking-tight">Jewels Ashu Circle</h2>
            <p className="mt-4 max-w-xl mx-auto" style={{ color: "var(--ja-muted)" }}>An invitation-only rewards programme for our most cherished clients.</p>
          </div>
          <div className="grid md:grid-cols-4 gap-12 md:gap-4">
            {[
              ["01", "Join", "Create your private account in seconds."],
              ["02", "Shop", "Earn 5 Circle points for every ₹100 spent."],
              ["03", "Earn", "Unlock anniversary gifts and previews."],
              ["04", "Redeem", "Convert points to credit or rare pieces."],
            ].map(([n, t, d]) => (
              <div key={n} className="border-t pt-8" style={{ borderColor: "var(--ja-border)" }}>
                <p className="ja-serif text-5xl" style={{ color: "var(--ja-gold)" }}>{n}</p>
                <p className="ja-serif text-2xl mt-6">{t}</p>
                <p className="mt-3 text-sm" style={{ color: "var(--ja-muted)" }}>{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* REVIEWS */}
      <section className="ja-section ja-container" data-testid="reviews-section">
        <div className="text-center mb-16">
          <p className="ja-overline">From the Clientele</p>
          <h2 className="ja-serif text-4xl md:text-5xl mt-3 tracking-tight">A Wall of Whispers</h2>
        </div>
        <div className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8">
          {REVIEWS.map((r, i) => (
            <figure key={i} className="break-inside-avoid border-l-2 pl-6 py-3" style={{ borderColor: "var(--ja-gold)" }}>
              <blockquote className="ja-serif text-2xl leading-snug">"{r.text}"</blockquote>
              <figcaption className="mt-5 text-[11px] tracking-[0.3em] uppercase" style={{ color: "var(--ja-muted)" }}>{r.name} · {r.city}</figcaption>
            </figure>
          ))}
        </div>
      </section>

      {/* INSTAGRAM */}
      <section className="pb-12" data-testid="instagram-gallery">
        <div className="ja-container text-center mb-10">
          <p className="ja-overline">@jewelsashu</p>
          <h2 className="ja-serif text-3xl md:text-4xl mt-3 tracking-tight">Follow the Light</h2>
        </div>
        <div className="grid grid-cols-3 md:grid-cols-6">
          {INSTA.map((src, i) => (
            <a key={i} href="https://www.instagram.com/jewels.ashu?igsh=M2VxOXViNHJlbWZy" className="block aspect-square overflow-hidden" data-testid={`instagram-${i}`}>
              <img src={src} alt="" className="w-full h-full object-cover ja-hover-img" loading="lazy" />
            </a>
          ))}
        </div>
      </section>
    </div>
  );
}

function SectionGrid({ title, overline, items, testid, ctaTo }) {
  return (
    <section className="ja-section ja-container" data-testid={testid}>
      <div className="flex items-end justify-between mb-12 flex-wrap gap-4">
        <div>
          <p className="ja-overline">{overline}</p>
          <h2 className="ja-serif text-4xl md:text-5xl mt-3 tracking-tight">{title}</h2>
        </div>
        <Link to={ctaTo} className="ja-overline hover:underline" data-testid={`${testid}-viewall`}>View all →</Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-12">
        {items.map((p, i) => <ProductCard key={p.id} p={p} idx={i} />)}
      </div>
    </section>
  );
}

function Storytelling({ overline, title, desc, cta, ctaTo, img, items, testid, reverse }) {
  return (
    <section className="ja-section ja-container" data-testid={testid}>
      <div className={`grid md:grid-cols-2 gap-12 md:gap-20 items-center ${reverse ? "md:[&>*:first-child]:order-2" : ""}`}>
        <div className="aspect-[4/5] overflow-hidden">
          <img src={img} alt="" className="w-full h-full object-cover ja-hover-img" loading="lazy" />
        </div>
        <div>
          <p className="ja-overline">{overline}</p>
          <h2 className="ja-serif text-4xl md:text-6xl mt-4 tracking-tight leading-tight">{title}</h2>
          <p className="mt-6 max-w-md" style={{ color: "var(--ja-muted)" }}>{desc}</p>
          <Link to={ctaTo} className="ja-btn mt-10" data-testid={`${testid}-cta`}>{cta}</Link>
        </div>
      </div>
      <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-12">
        {items.map((p, i) => <ProductCard key={p.id} p={p} idx={i} />)}
      </div>
    </section>
  );
}
